const invitation_auth_accept_model = require('civicsModels/portal/authorized_user_accept_invitation_model');
const invitation_applicant_accept_model = require('civicsModels/portal/invitation_model');
const constants = require('civicsUtils/constants');

define(function (require) {
	return {
      usesInviteeNewUX: function() {
            return App.featureToggles.INVITEE_UX;
      },
      getStoredInvite: function() {
		var inviteStored = App.sessionStorage.get('CIVICS', 'INVITE_RECORD');
            if(inviteStored!=null && inviteStored.length>0){
                  return inviteStored[0];
            }
            return null;;
      },
      getStoredAuthInvite: function() {
            var inviteStored = App.sessionStorage.get('CIVICS', 'AUTHORIZEDUSER_INVITE');
            if(inviteStored!=null){
                  return inviteStored;
            }
            return null;
      },
      createAddtlApplicantPayload: function(invite) {
            // Takes the invite from session storage and creates
            // the payload for the api/portal/invitations call
            let payload = {
                  id: invite.id || invite.inviteKey,
                  acceptedDateTime: constants.DATE_TIME_MIN_VAL,
                  invitationCode: decodeURIComponent(invite.inviteCodeEnc || invite.inviteCode),
            };

            return payload;
      },
      createAuthInvitePayload: function(invite) {
            // Takes the invite from session storage and create 
            // the payload for the api/portal/authorizeduser/invitation/accept call
            let payload = {
                  invitationToken: decodeURIComponent(invite.inviteCodeEnc || invite.inviteCode),
                  id: invite.id
            };

            return payload;
      },
      acceptAuthInvite: function(payload) {
            // PUT to api/portal/authorizeduser/invitation/accept
            let returnDefObj = $.Deferred();
            let acceptAuthInviteModel = new invitation_auth_accept_model();

            acceptAuthInviteModel.save(payload, {
                  type: 'PUT',
                  success: function (model, response, options) {
                       returnDefObj.resolve(response.data);
                  },
                  error: function (model, response, options) {
                        returnDefObj.reject(response);
                  },
            });
            
            return returnDefObj;
      },
      acceptAddtlApplicantInvite: function(payload) {
            // PUT to api/portal/invitations
            let returnDefObj = $.Deferred();

            let acceptApplicantInviteModel = new invitation_applicant_accept_model();

            acceptApplicantInviteModel.save(payload, {
                  type: 'PUT',
                  success: function (model, response, options) {
                       returnDefObj.resolve(response.data);
                  },
                  error: function (model, response, options) {
                        returnDefObj.reject(response);
                  },
            })

            return returnDefObj;
      }
	}

});